/**
 * 
 */
Converia.Core.module('Converia.Invoice.PaymentFormHandler', function () {
    /**
     * PAYMENTKIND
     * 
     * @type {{POS: string}}
     */
    var PAYMENTKIND = {
        POS: 'POS'
    };

    /**
     * PaymentFormHandler
     * 
     * @param begui
     * @constructor
     */
    var PaymentFormHandler = function (begui) {
        var self = this;

        $(begui).on('append-ajax-form-handler', function (event, eventData) {
            var form = eventData.form;
            var config = eventData.config;

            if (form.id === 'cashform_form_element') {
                config.beforeSubmit = $.proxy(self.beforeSubmit, self);
            }
        });
    };

    /**
     * getPaymentProcessStrategieForSelectedPayment
     * 
     * @param paymentKindElement
     * @param form
     * @returns {*}
     */
    var getPaymentProcessStrategieForSelectedPayment = function (paymentKindElement, form) {
        var selectedOption = paymentKindElement.selectedOptions[0];
        var paymentkey = '';

        if (selectedOption && $(selectedOption).data('paymentkey')) {
            paymentkey = $(selectedOption).data('paymentkey');
        }

        switch (paymentkey) {
            case PAYMENTKIND.POS:
                if ($(form).data('pos-mock')) {
                    var electronService = new Converia.Invoice.ElectronMockService();
                } else {
                    var electronService = new Converia.Invoice.ElectronService();
                }

                return new Converia.Invoice.PosStrategie(
                    form,
                    electronService
                );
                break;
            default:
                return new Converia.Invoice.PaymentDefaultStrategie();
        }
    };

    /**
     * PaymentFormHandler.prototype.beforeSubmit
     * 
     * @param arr
     * @param $form
     * @param options
     * @returns {boolean}
     */
    PaymentFormHandler.prototype.beforeSubmit = function (arr, $form, options) {
        var form = $form[0];
        var paymentKindElement = form.elements.namedItem('payment_id');

        if (!paymentKindElement) {
            BEGUI.getInstance().pushMessage(BEGUI.MESSAGETYPE.ERROR, 'Element for payment kind not found.');
            return false;
        }
        
        var strategie = getPaymentProcessStrategieForSelectedPayment(paymentKindElement, form);

        if ($form.attr('pending')) {
            var begui = BEGUI.getInstance();
            begui.processEnded();

            return false;
        } else {
            if (strategie.handleBeforeSubmit()) {
                $form.attr('pending',true);

                return true;
            } else {
                return false;
            }
        }
        
    };

    return PaymentFormHandler;
});